import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'softwareVersion'
})
export class SoftwareVersionPipe implements PipeTransform {

  transform(value: string, consoleType?: string): string {
    if (value != null) {
      if(value.length === 5){
          value = '0'+value;
      }        
    return `${parseInt(value.substr(0, 2))}.${parseInt(value.substr(2, 2))}.${consoleType ===  'discover' ? value.substr(4) : parseInt(value.substr(4))}`;
    }
    else {
      return "";
    }
  }

}
